import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

import analyticsCenterReducer from './AnalyticsCenter';
import analyticsReportReducer from './AnalyticsCenter/analyticsReport';
import automaticAssessmentReducer from './AnalyticsCenter/automaticAssessment';
import benefitHistoryReducer from './AnalyticsCenter/benefitHistory';
import businessNewsReducer from './AnalyticsCenter/businessNews';
import businessProfileReducer from './AnalyticsCenter/businessProfile';
import capitalRasingHistoryReducer from './AnalyticsCenter/capitalRasingHistory';
import economicInfoReducer from './AnalyticsCenter/economicInformation';
import serviceStockInformationReducer from './AnalyticsCenter/stockInformation';
import transactionHistoryReducer from './AnalyticsCenter/transactionHistory';
import newsEventListReducer from './News';
import companyGovernanceSituationReducer from './News/companyGovernanceSituation';
import disclosuresReducer from './News/disclosures';
import reportsReducer from './News/reports';
import sgdckNewsReducer from './News/sgdckNews';
import newsVideoReducer from './News/video';
import productServiceGuideReducer from './TransactionSupport/productServiceGuide';
import allContentReducer from './allContent';
import associateCompanyReducer from './associateCompany';
import branchNetworkReducer from './branchNetwork';
import ekycReducer from './ekyc';
import exampleReducer from './example';
import individualCustomerReducer from './individualCustomers';
import institutionalCustomerReducer from './institutionalCustomers';
import layoutReducer from './layout';
import locationReducer from './location';
import menusReducer from './menus';
import recentDealsReducer from './recentDeals';
import recruitmentReducer from './recruitment';
import registerBondReducer from './registerBond';
import systemReducer from './system';
import userReducer from './user';

export const store = configureStore({
  devTools: process.env.NODE_ENV === 'development',
  reducer: {
    example: exampleReducer,
    menus: menusReducer,
    system: systemReducer,
    individual: individualCustomerReducer,
    institutional: institutionalCustomerReducer,
    economicInfo: economicInfoReducer,
    associateCompany: associateCompanyReducer,
    businessNews: businessNewsReducer,
    businessProfile: businessProfileReducer,
    capitalRasingHistory: capitalRasingHistoryReducer,
    analyticsCenter: analyticsCenterReducer,
    analyticsReport: analyticsReportReducer,
    transactionHistory: transactionHistoryReducer,
    serviceStockInformation: serviceStockInformationReducer,
    user: userReducer,
    recentDeals: recentDealsReducer,
    productServiceGuide: productServiceGuideReducer,
    location: locationReducer,
    branchNetwork: branchNetworkReducer,
    disclosures: disclosuresReducer,
    automaticAssessment: automaticAssessmentReducer,
    newsVideo: newsVideoReducer,
    reports: reportsReducer,
    sgdckNews: sgdckNewsReducer,
    newsEventList: newsEventListReducer,
    companyGovernanceSituation: companyGovernanceSituationReducer,
    benefitHistory: benefitHistoryReducer,
    allContent: allContentReducer,
    layout: layoutReducer,
    recruitment: recruitmentReducer,
    registerBond: registerBondReducer,
    ekyc: ekycReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
